const e = "380px", o = "465px", c = "640px", p = "768px", r = "1024px", l = "1280px", s = {
  "2xs": "300px",
  xs: e,
  tiny: o,
  sm: c,
  md: p,
  "2md": "960px",
  lg: r,
  xl: l,
  "2xl": "1536px",
  "3xl": "1920px"
}, m = (() => {
  const t = {};
  for (const [x, n] of Object.entries(s))
    t[x] = Number.parseInt(n, 10);
  return Object.freeze(t);
})(), b = s;
export {
  m as BREAKPOINTS,
  b as BREAKPOINTS_JSON
};
